import React, { useLayoutEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { PormotionNews } from "./prCenter-news";
import { PromotionTechnology } from "./prCenter-technology";
import { PromotionCatalogue } from "./prCenter-catalogue";
import { PromotionVideo } from "./prCenter-video";
import { PromotionNewsView } from "./prCenter-news-view";
export interface Props {setData : Function}
export const PromotionCenter:React.FC<Props> = ({setData}) => {
    const {thridUrl}= useParams()
    const location = useLocation()
    const pathname = location.pathname;
    const path = location.pathname.split('/')
    useLayoutEffect(() =>{
        switch(pathname){
            case '/prCenter/news' : setData((prev:any)=>({...prev, title_2_kr : '보도자료', title_2_en : 'Press Release', className_2 : 'press_release pr_center_list'})); break;
            case `/prCenter/news/${thridUrl}` : setData((prev:any)=>({...prev, title_2_kr : '보도자료', title_2_en : 'Press Release', className_2 : 'press_release_view'})); break;
            case '/prCenter/technology' : setData((prev:any)=>({...prev, title_2_kr : '기술자료', title_2_en : 'Technology Article', className_2 : 'technic_article'})); break;
            case '/prCenter/promotion/catalogue' : setData((prev:any)=>({...prev, title_2_kr : '홍보자료', title_2_en : 'Promotion Materials', className_2 : 'promotional_materials'})); break;
            case '/prCenter/promotion/video' : setData((prev:any)=>({...prev, title_2_kr : '홍보자료', title_2_en : 'Promotion Materials', className_2 : 'press_release pr_center_list'})); break;
        }
    }, [location])
    return(
        <>
        {pathname === '/prCenter/news' ? <PormotionNews/> : ''}
        {pathname === `/prCenter/news/${thridUrl}` ? <PromotionNewsView/> : ''}
        {pathname === '/prCenter/technology' ? <PromotionTechnology/> : ''}
        {pathname === '/prCenter/promotion/catalogue' ? <PromotionCatalogue/> : ''}
        {pathname === '/prCenter/promotion/video' ? <PromotionVideo/> : ''}
        </>
    )
}